<template>
  <div id="home">
    <my-header @changeSource="changeSource"></my-header>
    <div class="pd20">
      <loading v-if="loading" class="mt10 text-center" :text="'Please wait'|translate"></loading>
      <div v-if="!loading" class="home-div">
        <div id="search-box" v-if="allProducts">
         <!-- <p class="my-address" v-if="search_params.address">
            <a
              target="_blank"
              :href="'https://www.google.com/maps?q='+search_params.lat+','+search_params.lng"
            >
              <i class="fas fa-location-arrow"></i>
              {{'Your address'|translate}} : {{search_params.address}}
            </a>
          </p>
          -->
          <current-address-control :object="search_params" ></current-address-control>
          <div class="search-wrapper">
            <div class="input-group">
              <autocomplete
                input-class="form-control"
                :placeholder="'Search' | translate"
                :source="allProducts"
                @selected="selectedProduct"
              ></autocomplete>
              <a
                class="btn btn-success"
                v-on:click="doSearch"
                style="display:table-cell;"
              >{{'Search'|translate}}</a>
            </div>
            <a class="btn btn-default" v-on:click="showAdvantageSearch()" title="Tìm kiếm nâng cao">
              <i class="fa fa-filter"></i>
            </a>
          </div>
        </div>
        <div class="list-products">
          <h3 class="text-center" v-if="source == 'garden'">{{'Find gardens by product'|translate}}</h3>
          <h3 class="text-center" v-if="source == 'store'">{{'Find stores by product'|translate}}</h3>

          <div class="row">
            <div class="col-md-3 col-xs-6" v-for="(product) in loaded_products" :key="product.id">
              <div class="product-item">
                <a v-on:click="search(product)">
                  <img :src="product.feature_image_path" />
                </a>
                <a v-on:click="search(product)">{{product.name}}</a>
              </div>
            </div>
          </div>
          <a
            class="view-more-product"
            v-if="!is_view_all_product && allProducts && allProducts.length > 8"
            v-on:click="viewAllProducts()"
          >Xem tất cả sản phẩm</a>
        </div>
      </div>
      <!-- <div v-if="!user">
        <div class="become-seller register-guide">
          <p>Bạn muốn kinh doanh bơ ?</p>
          <p>
            <router-link
              class="btn btn-success"
              :to="{ name: 'RegisterPage', params: { type:'seller' }}"
            >Đăng ký</router-link>
          </p>
        </div>
        <div class="become-farmer register-guide">
          <p>Bạn là nhà vườn ?</p>
          <p>
            <router-link
              class="btn btn-success"
              :to="{ name: 'RegisterPage', params: { type:'farmer' }}"
            >Đăng ký</router-link>
          </p>
        </div>
      </div> -->
    </div>
    <!-- end pd20 -->
    <advantagesearch
      v-if="show_advantage_search"
      ref="advantagesearch"
      :searchparams="search_params"
      @updatedAdvantageSearch="updatedAdvantageSearch"
    ></advantagesearch>
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import LocationHelper from '@/helpers/location'
import MyHeader from '@/components/Layout/Header'
import Autocomplete from 'vuejs-auto-complete'
import advantagesearch from '@/components/elements/AdvantageSearch'
import CurrentAddressControl from '@/components/elements/CurrentAddressControl'

import Loading from '@/components/elements/Loading'
export default {
  name: 'Home',
  components: {
    MyHeader,
    Autocomplete,
    advantagesearch,
    CurrentAddressControl,
    Loading
  },
  data () {
    return {
      loading: true,
      loaded_products: [],
      working_add_more: false,
      is_view_all_product: false,
      selected_product: null,
      allProducts: [],
      user: null,
      source: 'garden',
      search_params: {
        address: '',
        lat: null,
        lng: null,
        dist: 0
      },
      show_advantage_search: false
    }
  },

  methods: {
    changeSource (source) {
      this.source = source
      console.log('source', source)
    },
    showAdvantageSearch () {
      this.show_advantage_search = true
      setTimeout(() => {
        this.$refs.advantagesearch.open()
      })
    },

    selectedProduct (product) {
      this.selected_product = product.selectedObject
    },
    getMyLocation () {
      LocationHelper.getMyLocationWithAddress().then((position) => {
        this.search_params.lat = position.lat
        this.search_params.lng = position.lng
        this.search_params.address = position.address
      })
    },
    doSearch () {
      if (!this.selected_product) {
        return this.$alertify.alertWithTitle(
          this.$t('Confirm'),
          this.$t('You need input product name for search')
        )
      }
      console.log('this.selectedProduct', this.selected_product)
      this.search(this.selected_product)
    },
    getSourcePage () {
      let source = this.$localStorage.get('source')
      // console.log('source blah',source)
      return source || 'garden'
    },
    search (product) {
      if (this.search_params.lat === null) {
        return this.$alertify.alertWithTitle(
          this.$t('Confirm'),
          this.$t('We need your location for search result'),
          () => {
            this.showAdvantageSearch()
          }
        )
      }
      let params = {
        productId: product.id,
        productName: product.name,
        lat: this.search_params.lat,
        lng: this.search_params.lng
      }

      let name = ''
      if (this.source == 'garden') {
        name = 'SearchGarden'
        if (this.search_params.dist > 0) {
          params.km = this.search_params.dist
          name = 'SearchGardenKM'
        }
      } else {
        name = 'SearchStore'
        if (this.search_params.dist > 0) {
          params.km = this.search_params.dist
          name = 'SearchStoreKM'
        }
      }
      console.log('name', name)

      this.$router.push({ name: name, params: params })
    },
    updatedAdvantageSearch (obj) {
      // console.log('obj',obj)
      for (let key in obj) {
        this.search_params[key] = obj[key]
      }
      this.cacheLocation()
    },
    viewAllProducts () {
      this.is_view_all_product = true
      this.loadMoreProducts()
    },
    loadMoreProducts () {
      let count = this.loaded_products.length
      if (count >= this.allProducts.length) {
        this.removeListen()
        return
      }
      let nextIndex = count + 12
      nextIndex =
        nextIndex > this.allProducts.length
          ? this.allProducts.length
          : nextIndex
      let sub = this.allProducts.slice(count, nextIndex)
      sub.forEach(item => {
        this.loaded_products.push(item)
      })
      this.working_add_more = false
    },
    getRandomInt (min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min)
    },
    duplicateProducts () {
      for (let i = 0; i < 50; i++) {
        let item = JSON.parse(
          JSON.stringify(
            this.allProducts[this.getRandomInt(0, this.allProducts.length - 1)]
          )
        )
        item.id = i + 100
        // console.log(item)

        this.allProducts.push(item)
      }
    },
    onScroll (event) {
      if (this.working_add_more || !this.is_view_all_product) {
        return
      }
      let o = event.target
      if (o.offsetHeight + o.scrollTop - o.scrollHeight > -40) {
        this.working_add_more = true
        this.loadMoreProducts()
      }
    },
    removeListen () {
      let scrolledDiv = document.getElementById('main')
      scrolledDiv.removeEventListener('scroll', this.onScroll)
    }
  },
  mounted () {
    this.source = location.pathname == '/stores' ? 'store' : 'garden'
    Utils.getAllProducts(this, {}).then(data => {
      this.loading = false
      this.allProducts = data
      this.loaded_products = this.allProducts.slice(0, 8)
      // this.duplicateProducts()
      window.all = this.allProducts
    })

    this.user = Utils.getUser(this)
    if (this.user) {
      if (
        this.user.address &&
          this.user.location &&
          this.user.location.length == 2
      ) {
        this.search_params.address = this.user.address
        this.search_params.lat = this.user.location[0]
        this.search_params.lng = this.user.location[1]
      } else {
        setTimeout(() => {
          this.getMyLocation()
        })
      }
    } else {
      setTimeout(() => {
        this.getMyLocation()
      })
    }

    let scrolledDiv = document.getElementById('main')
    scrolledDiv.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    // prevent duplicated event
    this.removeListen()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/Home.vue